const submittedByInput = (form) =>
  form.querySelector('input[name="submitted_by"]') ??
  form.appendChild(Object.assign(document.createElement('input'), { type: "hidden", name: "submitted_by" }));

document.addEventListener("page:load", () => {
  document.querySelectorAll('.js-form-submitter').forEach((submitter) => {
    submitter.addEventListener('click', (e) => {
      submittedByInput(e.currentTarget.form).value = e.currentTarget.name;
    });
  });
});
